"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toProfileListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toProfileListSlice = function (data, logger) {
    return utils_1.compact(__assign(__assign({}, slice_1.toAnchoredSlice(data, types_1.SliceType.ProfileList)), { title: logger.required(fields_1.toText(data.primary.title)), documents: data.items
            .map(function (item) { return fields_1.toDocumentLink(item.document, logger); })
            .filter(Boolean) }));
};
exports.toProfileListSlice = toProfileListSlice;
//# sourceMappingURL=profile-list-slice.js.map